export const messages = {
    en_more_records: {
      "grid.pagerInfo": "{0} - {1} of {2}+ items",
    },
    en: {
      "grid.pagerInfo": "{0} - {1} of {2} items",
    }
  };